import React from 'react';
import api from '../api/client';

class CheckoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.customer?.email || '',
      provider: 'paystack',
      cartTotal: 0,
      loading: true,
      submitting: false,
      error: null
    };
  }

  componentDidMount() {
    api.getCart()
      .then((cart) => this.setState({ cartTotal: cart.total, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email, provider } = this.state;
    if (!email) return this.setState({ error: 'Email is required' });

    this.setState({ submitting: true, error: null });
    api.checkout(email, provider)
      .then((result) => {
        // Both providers return a hosted checkout_url to redirect the whole
        // browser to — Paystack's page or Squad's page.
        window.location.href = result.checkoutUrl;
      })
      .catch((err) => {
        this.setState({
          submitting: false,
          error: err.response?.data?.error || 'Checkout failed. Please try again.'
        });
      });
  };

  render() {
    const { email, provider, cartTotal, loading, submitting, error } = this.state;
    if (loading) return <p className="loading">Loading...</p>;

    return (
      <div className="checkout-page">
        <h1>Checkout</h1>
        <p>Total due: <strong>₦{Number(cartTotal).toLocaleString()}</strong></p>

        <form onSubmit={this.handleSubmit}>
          <label>
            Email address
            <input
              type="email"
              required
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </label>

          <fieldset>
            <legend>Payment method</legend>
            <label>
              <input
                type="radio"
                checked={provider === 'paystack'}
                onChange={() => this.setState({ provider: 'paystack' })}
              />
              Paystack (card, bank transfer, USSD)
            </label>
            <label>
              <input
                type="radio"
                checked={provider === 'squad'}
                onChange={() => this.setState({ provider: 'squad' })}
              />
              Squad by GTCO
            </label>
          </fieldset>

          {error && <p className="error">{error}</p>}

          <button className="btn btn-primary" type="submit" disabled={submitting}>
            {submitting ? 'Redirecting...' : 'Pay now'}
          </button>
        </form>
      </div>
    );
  }
}

export default CheckoutPage;
